import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import App from "./App.jsx";
import { registerServiceWorker } from "./services/notifications.js";

// Enregistrer le Service Worker pour PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    registerServiceWorker().then((registration) => {
      if (registration) {
        console.log('[App] PWA prete');
      }
    });
  });
}

createRoot(document.getElementById("root")).render(<App />);
